import type { SectionBankInfo } from '@/shared/types';
import { Checkbox } from '../atoms/Checkbox';
import { Input } from '../atoms/Input';

const EMPTY_BANK_INFO: SectionBankInfo = { bankName: '', accountHolder: '', clabe: '' };

interface SectionBankInfoFieldsProps {
  /** `null` = la sección usa la cuenta del residencial. */
  value: SectionBankInfo | null;
  onChange: (value: SectionBankInfo | null) => void;
}

/** Cuenta bancaria propia de una sección (Secciones y Configuración → Financiero). */
export const SectionBankInfoFields = ({ value, onChange }: SectionBankInfoFieldsProps) => (
  <div className="space-y-3">
    <Checkbox
      label="Cuenta bancaria propia"
      checked={!!value}
      onChange={(checked) => onChange(checked ? value ?? EMPTY_BANK_INFO : null)}
    />
    {value ? (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Input
          label="Banco"
          value={value.bankName}
          onChange={(e) => onChange({ ...value, bankName: e.target.value })}
          autoComplete="off"
          required
        />
        <Input
          label="Titular"
          value={value.accountHolder}
          onChange={(e) => onChange({ ...value, accountHolder: e.target.value })}
          autoComplete="off"
          required
        />
        <Input
          label="CLABE"
          value={value.clabe}
          onChange={(e) => onChange({ ...value, clabe: e.target.value.replace(/\D/g, '') })}
          inputMode="numeric"
          pattern="\d{18}"
          maxLength={18}
          title="18 dígitos"
          autoComplete="off"
          className="font-mono"
          required
        />
        <Input
          label="Número de cuenta"
          value={value.accountNumber ?? ''}
          onChange={(e) => onChange({ ...value, accountNumber: e.target.value })}
          autoComplete="off"
        />
      </div>
    ) : (
      <p className="text-xs text-slate-500">
        Esta sección no tiene cuenta propia: sus residentes pagan a la cuenta general del residencial.
      </p>
    )}
  </div>
);
